module.exports = __webpack_public_path__ + "static/media/06.65867f71.jpeg";